import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { Box, Stack } from '@mui/material'
import TabViewer from './TabViewer'
import TabSwitcher from './TabSwitcher'
import CardWidget from './CardWidget'
import AuctionQueryLanguage from './AuctionQueryLanguage'
import type { DashboardCardDef } from '@edge/spark/io-dashboards'
import type { DashboardCardConfig } from './types'
import { convertDashboardCardDefToDashboardCardConfig } from './converters'
import { RhfDebug } from '@edge/spark/feature-mui-rhf-inputs'

interface Props {
    widgetDef: DashboardCardDef
    readOnly: boolean
}

export const CardConfigurator: React.VFC<Props> = ({ widgetDef, readOnly }: Props) => {
    const isContactCard = !!widgetDef.config?.contactLogSearch

    return (
        <div>
            {readOnly ? (
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        margin: 'auto',
                        p: 2,
                        width: 200 * widgetDef.width,
                    }}
                >
                    <CardWidget widgetDef={widgetDef} />
                </Box>
            ) : (
                <Box>
                    <Box sx={{ mt: 1 }}>
                        <AuctionQueryLanguage />
                    </Box>
                    <Box sx={{ my: 1 }}>
                        <TabSwitcher isContactCard={isContactCard} />
                    </Box>
                    <Stack direction={{ xs: 'column', md: 'row' }}>
                        <Box sx={{ flex: 1, minHeight: '400px' }}>
                            <TabViewer />
                        </Box>
                        <Box
                            sx={{
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                margin: 'auto',
                                p: 2,
                                width: 200 * widgetDef.width,
                                pl: { xs: 2, md: 10 },
                                pr: { xs: 0, md: 8 },
                            }}
                        >
                            <CardWidget widgetDef={widgetDef} />
                        </Box>
                    </Stack>
                </Box>
            )}
            <RhfDebug />
        </div>
    )
}

export default CardConfigurator
